var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGatilho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8462 25C10.3538 25 9.92308 24.8885 9.55385 24.6655C9.18462 24.4425 9 24.1823 9 23.885V17.8827C9 17.6969 9.03077 17.5389 9.09231 17.4088C9.15385 17.2787 9.26667 17.158 9.43077 17.0465L11.1538 15.6341C11.3179 15.5226 11.5077 15.4452 11.7231 15.4019C11.9385 15.3585 12.1937 15.3368 12.4888 15.3368H21.5112C21.8063 15.3368 22.0564 15.3585 22.2615 15.4019C22.4667 15.4452 22.6513 15.5226 22.8154 15.6341L24.5692 17.0465C24.7333 17.158 24.8462 17.2787 24.9077 17.4088C24.9692 17.5389 25 17.6969 25 17.8827V23.885C25 24.1823 24.8154 24.4425 24.4462 24.6655C24.0769 24.8885 23.6462 25 23.1538 25H10.8462ZM11.3692 17.3066H22.6L21.4797 16.4518H12.4769L11.3692 17.3066ZM10.8462 18.4216V23.885H23.1538V18.4216H10.8462ZM17 14.7793L21.8 11.8804L20.5692 11.1371L17.9231 12.7352V9H16.0769V12.7352L13.4308 11.1371L12.2 11.8804L17 14.7793Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGatilho);
export default __webpack_public_path__ + "static/media/icon-gatilho.b8f8dd53.svg";
export { ForwardRef as ReactComponent };